import { USER_ROLES } from '../../constants/userRoles';

export const PERFIL_ROLE_LABELS = {
  [USER_ROLES.PACIENTE]: 'Paciente',
  [USER_ROLES.MEDICO]: 'Médico',
};

export const PERFIL_FIELDS_BY_ROLE = {
  [USER_ROLES.PACIENTE]: [
    { key: 'dni', label: 'DNI', type: 'text', inputMode: 'numeric' },
    { key: 'obraSocial', label: 'Obra social', type: 'text' },
    { key: 'plan', label: 'Plan', type: 'text' },
    { key: 'nombreUsuario', label: 'Usuario', type: 'text' },
    { key: 'password', label: 'Contraseña', type: 'password' },
  ],
  [USER_ROLES.MEDICO]: [
    { key: 'matricula', label: 'Matrícula', type: 'text' },
    { key: 'nombreUsuario', label: 'Usuario', type: 'text' },
    { key: 'password', label: 'Contraseña', type: 'password' },
  ],
};

export const PERFIL_NOMBRE_FIELD = {
  key: 'nombre',
  label: 'Nombre completo',
  type: 'text',
};
